<template>
  <div class="mail-settings">
    <div class="title">送信先設定</div>
    <div class="mail-contents">
      <div class="content">
        <div class="OnOffToggle">
          <div class="item-frame">
            <label
              class="text"
              for="settingTeamsMail">Teams投稿先メールアドレス</label>
            <input
              id="settingTeamsMail"
              v-model="teamsMail.use"
              type="checkbox"
              class="checkbox"
              checked="checked"
              @change="toggleMailUse(mailPath.teams)" />
            <label
              class="switch"
              for="settingTeamsMail"></label>
          </div>
        </div>
        <p
          v-if="teamsMail.error && teamsMail.use"
          :class="[teamsMail.errorTypeIsDanger ? 'attentionMessage' : 'infoMessage']">{{ teamsMail.error }}</p>
        <input
          v-if="teamsMail.use"
          v-model="teamsMail.address"
          :class="[teamsMail.error ? (teamsMail.errorTypeIsDanger ? 'attention' : 'info') : '']"
          type="text"
          class="content-input"
          placeholder="日報を投稿するTeamsチャネルのアドレス"
          @keydown="keyboardInput(mailPath.teams)"
          @keydown.enter.exact="saveMailAddress(mailPath.teams)">
        <div
          v-if="teamsMail.use"
          class="content-obj">
          <button
            class="save-mail"
            @click="saveMailAddress(mailPath.teams)">保存</button>
          <a
            class="send-test"
            @click="sendTestMail(mailPath.teams, teamsMail.address)">テスト送信</a>
        </div>
      </div>
      <div class="content">
        <div class="OnOffToggle">
          <div class="item-frame">
            <label
              class="text"
              for="settingWorkMail">勤怠連絡先メールアドレス</label>
            <input
              id="settingWorkMail"
              v-model="workMail.use"
              type="checkbox"
              class="checkbox"
              checked="checked"
              @change="toggleMailUse(mailPath.work)" />
            <label
              class="switch"
              for="settingWorkMail"></label>
          </div>
        </div>
        <p
          v-if="workMail.error && workMail.use"
          :class="[ workMail.errorTypeIsDanger ? 'attentionMessage' : 'infoMessage']">{{ workMail.error }}</p>
        <input
          v-if="workMail.use"
          v-model="workMail.address"
          :class="[ workMail.error ? (workMail.errorTypeIsDanger ? 'attention' : 'info') : '' ]"
          type="text"
          class="content-input"
          placeholder="勤怠連絡を送信するアドレス"
          @keydown="keyboardInput(mailPath.work)"
          @keydown.enter.exact="saveMailAddress(mailPath.work)">
        <div
          v-if="workMail.use"
          class="content-obj">
          <button
            class="save-mail"
            @click="saveMailAddress(mailPath.work)">保存</button>
          <a
            class="send-test"
            @click="sendTestMail(mailPath.work, workMail.address)">テスト送信</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {db} from '@/plugins/firestore'
import ms from '@/utils/msGraphApi'
import sw from '@/utils/sweetAlert'
import config from '@/utils/const'

export default {
  data () {
    return {
      /**
       * パスの種別
       * @type {Object}
       */
      mailPath: config.mailPath,
      /**
       * Teams投稿関連の変数をまとめたオブジェクト
       * @type {Object}
       */
      teamsMail: {
        /**
         * Teams投稿機能を利用するかどうか
         * @type {Boolean}
         */
        use: false,
        /**
         * Teams投稿先メールアドレス
         * @type {String}
         */
        address: '',
        /**
         * teamsMail.addressのエラー保存場所
         * @type {String}
         */
        error: '',
        /**
         * teamsMail.errorのエラーのタイプ
         * @type {Boolean}
         */
        errorTypeIsDanger: true,
        /**
         * teamsMail.addressの設定が初めてかどうか
         * @type {Boolean}
         */
        first: false,
        /**
         *  teamsMail.addressを編集中かどうか
         * @type {Boolean}
         */
        hasChanged: false
      },
      /**
       * 勤怠連絡関連の変数をまとめたオブジェクト
       * @type {Object}
       */
      workMail: {
        /**
         * 勤怠連絡機能を利用するかどうか
         * @type {Boolean}
         */
        use: false,
        /**
         * 勤怠連絡先メールアドレス
         * @type {String}
         */
        address: '',
        /**
         * workMail.addressのエラー保存場所
         * @type {String}
         */
        error: '',
        /**
         * workMail.errorのエラーのタイプ
         * @type {Boolean}
         */
        errorTypeIsDanger: true,
        /**
         * workMail.addressの設定が初めてかどうか
         * @type {Boolean}
         */
        first: false,
        /**
         *  workMail.addressを編集中かどうか
         * @type {Boolean}
         */
        hasChanged: false
      }
    }
  },
  watch: {
    'teamsMail.address' () {
      this.teamsMail.error = ''
      // メールアドレスが空の場合
      if (!this.teamsMail.address) {
        this.teamsMail.error = 'メールアドレスを入力してください。'
        if (this.teamsMail.first) {
          this.teamsMail.errorTypeIsDanger = false
        } else {
          this.teamsMail.errorTypeIsDanger = true
        }
      }
    },
    'workMail.address' () {
      this.workMail.error = ''
      // メールアドレスが空の場合
      if (!this.workMail.address) {
        this.workMail.error = 'メールアドレスを入力してください。'
        if (this.workMail.first) {
          this.workMail.errorTypeIsDanger = false
        } else {
          this.workMail.errorTypeIsDanger = true
        }
      }
    }
  },
  created () {
    // ページ内に触れた後、リロードやブラウザを閉じようとすると警告
    window.addEventListener('beforeunload', this.confirmSave);

    this.fetchMailRelated()
  },
  destroyed () {
    window.removeEventListener('beforeunload', this.confirmSave);
  },
  methods: {
    /**
     * teams投稿、勤怠連絡関連の情報(使用するか・メールアドレス)を取得
     */
    async fetchMailRelated () {
      const self = this // グローバル変数のthis
      // allow関数は関数の外側のthisを関数内で参照する
      await db.doc(`tenants/${this.$store.state.tenant}`).get().then((doc) => {
        // teams
        if (doc.data().teamsMail === undefined) {
          self.teamsMail.address = ''
          self.teamsMail.use = true
        // hint: DBにフィールドなし > on→offに変更した場合のみ
        } else if (doc.data().teamsMail.address === undefined) {
          self.teamsMail.address = ''
          self.teamsMail.use = false
        } else {
          self.teamsMail.address = doc.data().teamsMail.address
          self.teamsMail.use = doc.data().teamsMail.use
        }

        // 勤怠
        if (doc.data().workMail === undefined) {
          self.workMail.address = ''
          self.workMail.use = true
        // hint: DBにフィールドなし > on→offに変更した場合のみ
        } else if (doc.data().workMail.address === undefined) {
          self.workMail.address = ''
          self.workMail.use = false
        } else {
          self.workMail.address = doc.data().workMail.address
          self.workMail.use = doc.data().workMail.use
        }
      }).catch((error) => {
        sw.toastAlert('error', '取得に失敗しました')
        console.error(`エラー:${error}`)
      })

      this.$store.commit('setTeamsMailAddress',this.teamsMail.address)
      this.$store.commit('setWorkMailAddress',this.workMail.address)

      this.configureMailRelated(config.mailPath.teams)
      this.configureMailRelated(config.mailPath.work)
    },
    /**
     * メールアドレスがundefined・空欄の時の処理
     * @param {String} path Teams投稿先か勤怠連絡先かを判別
     */
    configureMailRelated(path) {
      // teams投稿メールアドレスが設定されていないとき
      if (path === config.mailPath.teams) {
        if (this.$store.state.teamsMailAddress === '') {
          this.teamsMail.address = ''
          this.teamsMail.error = 'メールアドレスを入力してください。'
          this.teamsMail.errorTypeIsDanger = false
          this.teamsMail.first = true
        }

      // 勤怠連絡メールアドレスが設定されていないとき
      } else {
        if (this.$store.state.workMailAddress === '') {
          this.workMail.address = ''
          this.workMail.error = 'メールアドレスを入力してください。'
          this.workMail.errorTypeIsDanger = false
          this.workMail.first = true
        }
      }
    },
    /**
     * Teams投稿先か勤怠連絡先を保存
     * @param {String} path Teams投稿先か勤怠連絡先かを判別
     * @param {String} mailAddress 保存するメールアドレス
     */
    saveMailAddress (path) {
      let field = ''
      switch (path) {
        case config.mailPath.teams:
          // メールアドレスバリデーション成功
          if (this.validEmail(this.teamsMail.address)) {
            this.teamsMail.error = ''
            this.teamsMail.first = false
            this.teamsMail.hasChanged = false
            this.$store.commit('setTeamsMailAddress',this.teamsMail.address)
            field = {"teamsMail.address": this.teamsMail.address, "teamsMail.use": this.teamsMail.use}
            break
          } else {
            this.teamsMail.error = '有効なメールアドレスを入力してください。'
            this.teamsMail.errorTypeIsDanger = true
            return
          }
        case config.mailPath.work:
          // メールアドレスバリデーション成功
          if (this.validEmail(this.workMail.address)) {
            this.workMail.error = ''
            this.workMail.first = false
            this.workMail.hasChanged = false
            this.$store.commit('setWorkMailAddress',this.workMail.address)
            field = {"workMail.address": this.workMail.address, "workMail.use": this.workMail.use}
            break
          } else {
            this.workMail.error = '有効なメールアドレスを入力してください。'
            this.workMail.errorTypeIsDanger = true
            return
          }
        default:
          console.error(`不正なpathが読み込まれました。 => ${path}`)
          break
      }
      this.hasChanged()
      try {
        db.doc(`tenants/${this.$store.state.tenant}`).update(field).then(() => {
          sw.toastAlert('success', '保存しました')
        }).catch((error) => {
          sw.toastAlert('error', '保存に失敗しました')
          console.error(`エラー:${error}`)
        })
      } catch (error) {
        sw.toastAlert('error', '保存に失敗しました')
        console.error(`エラー:${error}`)
      }
    },
    /**
     * テストメールを送信
     * @param {String} path Teams投稿先か勤怠連絡先かを判別
     * @param {String} mailAddress 送信するメールアドレス
     */
    sendTestMail (path,mailAddress) {
      // メールアドレスバリデーション成功
      if (this.validEmail(mailAddress)) {
        if (path === config.mailPath.teams) {
          this.teamsMail.error = ''
        } else {
          this.workMail.error = ''
        }
        this.$swal({
          icon: 'info',
          html: `テストメールを送信します<br>【${mailAddress}】`,
          showCancelButton: true,
          reverseButtons: true
        }).then((result) => {
          if (result.isConfirmed) {
            const mailContent = {
              message: {
                subject: `テストメール ${this.$store.state.today.format('YYYY/MM/DD')}`,
                body: {
                  contentType: 'Text',
                  content: 'テストメール'
                },
                toRecipients: [{
                  emailAddress: {
                    address: mailAddress
                  }
                }]
              }
            }
            ms.sendMail(JSON.stringify(mailContent), 'sendTest')
          }
        })

      // メールアドレスバリデーション失敗
      } else {
        if (path === config.mailPath.teams) {
          this.teamsMail.error = '有効なメールアドレスを入力してください。'
          this.teamsMail.errorTypeIsDanger = true
        } else {
          this.workMail.error = '有効なメールアドレスを入力してください。'
          this.workMail.errorTypeIsDanger = true
        }
      }
    },
    /**
     * teamsに投稿するか切り替える
     * @param {String} path Teams投稿先か勤怠連絡先かを判別
     */
    toggleMailUse (path) {
      if (path === config.mailPath.teams) {
        if (this.teamsMail.hasChanged) {
          this.$swal({
            icon: 'info',
            html: '保存していない内容が破棄されます。<br>よろしいですか。',
            showCancelButton: true,
            confirmButtonText: 'OK',
            reverseButtons: true,
            allowOutsideClick: false
          }).then((result) => {
          // toggleのON/OFFもここでここで制御しないとだめ
            if (result.isConfirmed) {
              this.teamsMail.error = ''
              this.teamsMail.address = ''
              this.teamsMail.hasChanged = false
              this.hasChanged()
              this.updateMailUse(config.mailPath.teams)
            }
            else if (result.dismiss === 'cancel') {
              this.teamsMail.use = true
            }
          })
        } else {
          this.teamsMail.error = ''
          this.teamsMail.address = ''
          this.teamsMail.hasChanged = false
          this.hasChanged()
          this.updateMailUse(config.mailPath.teams)
        }
      } else {
        if (this.workMail.hasChanged) {
          this.$swal({
            icon: 'info',
            html: '保存していない内容が破棄されます。<br>よろしいですか。',
            showCancelButton: true,
            confirmButtonText: 'OK',
            reverseButtons: true,
            allowOutsideClick: false
          }).then((result) => {
            if (result.isConfirmed) {
              this.workMail.error = ''
              this.workMail.address = ''
              this.workMail.hasChanged = false
              this.hasChanged()
              this.updateMailUse(config.mailPath.work)
            }
            else if (result.dismiss === 'cancel') {
              this.workMail.use = true
            }
          })
        } else {
          this.workMail.error = ''
          this.workMail.address = ''
          this.workMail.hasChanged = false
          this.hasChanged()
          this.updateMailUse(config.mailPath.work)
        }
      }

    },
    /**
     * 条件を満たしたらteamsMail.useをDBに接続して更新する
     * @param {String} path Teams投稿先か勤怠連絡先かを判別
     */
    async updateMailUse (path) {
      if (path === config.mailPath.teams) {
      // OFF->ONにした時
        if (this.teamsMail.use) {
          this.teamsMail.address = this.$store.state.teamsMailAddress

          // addressがundefinedのときaddressは''となる
          this.configureMailRelated(config.mailPath.teams)
        }

        // OFFにした時、またはメールアドレスがDBに保存されている時だけ更新
        if (!this.teamsMail.use || this.teamsMail.address !== '') {
          await db.doc(`tenants/${this.$store.state.tenant}`).update({
            "teamsMail.use": this.teamsMail.use
          }).then(() => {
            sw.toastAlert('success', '保存しました')
          }).catch((error) => {
            sw.toastAlert('error', '保存に失敗しました')
            console.error(`エラー:${error}`)
          })
        }
      } else {
        // OFF->ONにした時
        if (this.workMail.use) {
          this.workMail.address = this.$store.state.workMailAddress

          // addressがundefinedのときaddressは''となる
          this.configureMailRelated(config.mailPath.work)
        }

        // OFFにした時、またはメールアドレスがDBに保存されている時だけ更新
        if (!this.workMail.use || this.workMail.address !== '') {
          await db.doc(`tenants/${this.$store.state.tenant}`).update({
            "workMail.use": this.workMail.use
          }).then(() => {
            sw.toastAlert('success', '保存しました')
          }).catch((error) => {
            sw.toastAlert('error', '保存に失敗しました')
            console.error(`エラー:${error}`)
          })
        }
      }

    },
    /**
     * メールアドレスバリデーション
     * @param {String} email バリデーションをするメールアドレス
     * @returns {Boolean} メールアドレスバリデーションが成功かどうか
     */
    validEmail (email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    /**
     * 画面遷移に対して警告を出す
     * @param {Object} event addEventListener()を発火させたときに渡される引数
     */
    confirmSave (event) {
      // 編集中の時だけ警告を出す
      if (this.$store.state.hasChanged) {
        event.preventDefault()
        // メッセージ内容はブラウザによって固定されている。
        // Chromeなら「このサイトを再読み込みしますか？行った変更が保存されない可能性があります。」と表示される
        // returnValueで設定したメッセージを表示できるのはIEだ
        event.returnValue = '編集中のものは保存されませんが、よろしいですか？'
      }
    },
    /**
     * 入力を検知する
     * @param {String} path teamsMail.addressを編集中かworkMail.addressを編集中かどうかを判別
     */
    keyboardInput (path) {
      this.$store.commit('setHasChanged',true)

      if (path === config.mailPath.teams) {
        this.teamsMail.hasChanged = true
      } else {
        this.workMail.hasChanged = true
      }
    },
    /**
     * 現在編集中でなかったら、hasChangedをfalseにする
     */
    hasChanged () {
      if (!this.teamsMail.hasChanged && !this.workMail.hasChanged) {
        this.$store.commit('setHasChanged',false)
      }
    }
  }
}
</script>

<style scoped>
.mail-settings {
  width: auto;
  height: calc(100% - 45px);
  user-select: none;
  padding-left: 35px;
  overflow: auto;
}
.title{
  width: 90%;
  font-size: 18px;
  font-weight: 400;
  line-height: 24px;
  margin: 20px 0 10px 0;
  padding: 0 0 5px 5px;
  color: #777;
  border-bottom: 1px solid #777;
}
.mail-contents {
  min-width: 550px;
}
.content {
  margin: 0 0 40px 0;
}
.content-title {
  color: #777;
  font-size: 0.8em;
}
.save-mail {
  background-color: #cc0000;
  color: #ffffff;
  margin: 0 10px 0 0;
}
.send-test {
  cursor: pointer;
  font-size: 0.5em;
  color: #777;
}
button {
  height: 30px;
  display: inline-block;
  padding: 0px 14px;
  font-size: 0.8em;
  cursor: pointer;
  border: 1px solid transparent;
  border-radius: 3px;
}
button:focus {
  outline: none;
}
button:hover {
  background-color: #cc0000a6;
}
.initialize {
  color: white;
  background-color: #2c7eea;
}
.initialize:hover {
  background-color: #2c7eeaad;
}
input[type='text'] {
	box-sizing: border-box;
	width: 80%;
  max-width: 400px;
  height: 30px;
  font-size: 0.9em;
  margin: 0 0 10px 0;
	letter-spacing: 0.5px;
	color: #333;
	border: none;
	border-bottom: 1px solid #1b2538;
	background: transparent;
}
input[type='text']:focus {
	border-bottom: 2px solid #1a73e8;
	outline: none;
}
/* ====== ON/OFFトグルボタン ====== */
.OnOffToggle .item-frame {
  width: 400px;
  display: flex;
  justify-content: space-between;

}
.OnOffToggle .text {
  vertical-align: middle;
  color: #777;
  font-size: 0.9em;
}
.OnOffToggle label {
  cursor: pointer;
}
.OnOffToggle .switch {
  position: relative;
}
.OnOffToggle .switch:before, .OnOffToggle .switch:after {
  content: '';
  vertical-align: middle;
  display: inline-block;
}
.OnOffToggle .switch:before {
  width: 34px;
  height: 17px;
  border: 2px solid #999999;
  border-radius: 32px;
  background: #fff;
}
.OnOffToggle .switch:after {
  position: relative;
  width: 12px;
  height: 12px;
  background: #999999;
  border-radius: 50%;
  left: -2.2em;
}

.OnOffToggle input:checked ~ .switch:before {
  background: #fff;
  border-color:
#78bd78;
}

.OnOffToggle input:checked ~ .switch:after {
  background: #78bd78;
  left: -0.95em;
}

.OnOffToggle input {
  display: none;
}

.placeholderRed::placeholder {
  color: red;
}

.attention {
  background-color: #ffebe9!important;
}

.info {
  background-color: #cde4ff!important;
}

.attentionMessage {
  color: red;
  font-size: 0.7rem;
}

.infoMessage {
  color: #2c7eea;
  font-size: 0.7rem;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/Settings/SendMail.vue